import React from 'react';

import ShoppingCartStepOne from './ShoppingCartStepOne';
import ShoppingCartStepTwo from './ShoppingCartStepTwo';
import ShoppingCartStepThree from './ShoppingCartStepThree';
import './ShoppingCart.scss';

class ShoppingCart extends React.Component {
  render() {
    return (
      <div className='pt-2' id="shoppingCart" hidden={this.props.currentStep === 0}>
        <div className="container">
          <div className="row">
            {(() => {
              switch (this.props.currentStep) {
                case 0:
                  return;
                case 1:
                  return (<ShoppingCartStepOne
                    changeStep={this.props.changeStep}
                    canProceed={this.props.canProceed}
                  />);
                case 2:
                  return (<ShoppingCartStepTwo
                    changeStep={this.props.changeStep}
                    canProceed={this.props.canProceed}
                  />);
                case 3:
                  return (<ShoppingCartStepThree
                    changeStep={this.props.changeStep}
                    email={this.props.email}
                  />);
                case 4:
                case 5:
                  return null;
                default:
                  return (<ShoppingCartStepOne
                    changeStep={this.props.changeStep}
                    canProceed={this.props.canProceed}
                  />);
              }
            })()}
          </div>
        </div>
      </div>
    );
  }
}

export default ShoppingCart;
